import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'receipt-saving-confirmation',
    templateUrl: './receipt-saving-confirmation.component.html',
    styleUrls: ['./receipt-saving-confirmation.component.scss']
})
export class ReceiptSavingConfirmationComponent implements OnInit {
  private readonly dialogData = inject(MAT_DIALOG_DATA, { optional: true }) as {
    title?: string;
    message?: string;
    confirmLabel?: string;
  } | null;
  private dialogRef = inject<MatDialogRef<ReceiptSavingConfirmationComponent>>(MatDialogRef);

  title = 'Warning';
  message = 'Line item details is missing. Are you sure you want to reprocess this receipt?';
  confirmLabel = 'Push to reprocessing';


  ngOnInit() {
    if (this.dialogData) {
      this.title = this.dialogData.title ?? this.title;
      this.message = this.dialogData.message ?? this.message;
      this.confirmLabel = this.dialogData.confirmLabel ?? this.confirmLabel;
    }
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSubmit() {

    this.dialogRef.close(true);
  }

}
